import styled, { keyframes } from 'styled-components';

const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  font-family: proxima-nova, sans-serif;
  padding: 3rem 10rem;
  position: sticky;
  top: 0;
  z-index: 9999;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    padding: 3rem 6rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    padding: 3rem 4rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 3rem 4rem;
  }
`;

export const Logo = styled.div`
  img {
    height: 30px;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 6rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    gap: 4rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    gap: 2rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: ${({ theme }) => theme.color.mobilityGrey};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.size20};
  text-decoration: none;
  position: relative;
  padding: 1rem 0;

  &:hover {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }

  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 3.5rem);
  left: 0;

  animation: ${fadeInDown} 0.3s ease-out;
  background: #ffffff;
  border-radius: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  display: none;
  min-width: 200px;
  padding: 1rem 0;
`;

export const DropdownItem = styled.a`
  display: block;
  padding: 1rem 2rem;

  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size16};
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.color.lightGrey};
    color: ${({ theme }) => theme.color.mobilityBlue};
  }

  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const NavLinkWithDropdown = styled.div`
  position: relative;
  font-size: ${({ theme }) => theme.fontSize.size20};

  &:hover ${DropdownMenu} {
    display: block;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -3.5rem;
    left: 0;
    width: 100%;
    height: 3.5rem;
    background: transparent;
  }
`;

export const MobileMenuIcon = styled.div`
  cursor: pointer;
  font-size: 4rem;
  display: none;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: block;
  }
`;

export const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100vw;

  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

  padding: 1rem;
  z-index: 1000;
  text-align: center;
`;

export const MobileNavLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: end;
  gap: 1rem;

  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size20};

  padding: 1rem;
  margin-bottom: 1rem;

  position: relative;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }

  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const MobileDropdownMenu = styled.div<{ isOpen: boolean }>`
  background: #ffffff;
  font-size: ${({ theme }) => theme.fontSize.size16};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  margin-bottom: 1rem;

  max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
  width: 100%;
`;

export const MobileDropdownItem = styled.a`
  display: block;
  padding: 1rem 2rem;

  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size16};
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.color.mobilityBlue};
    background-color: ${({ theme }) => theme.color.white};
  }

  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const CloseIconWrapper = styled.span`
  position: absolute;
  right: 2rem;
  top: 1rem;
`;
